import { createAction, props } from '@ngrx/store';
import { ValidationRuleInvocationDto } from 'src/app/shared/lib/validations/models/validation-rule-invocation-return.model';

export const saveValidations = createAction(
    '[VALIDATIONS] Save Money Movement',
    props<{userId: number,marginId: number}>()
);

export const saveValidationsSuccess = createAction('[VALIDATIONS] Save Money Movement Validations Success');
export const saveValidationsFailure = createAction(
    '[VALIDATIONS] Save Money Movement Validations Failure',
    props<{ error: string }>()
);

export const getValidations = createAction(
    '[VALIDATIONS] Get Validations for Margin Id',
    props<{ marginId: number }>()
);

export const getValidationsSuccess = createAction(
    '[VALIDATIONS] Get Validations Success',
    props<{ validations: ValidationRuleInvocationDto[] }>()
);
export const getValidationsFailure = createAction('[VALIDATIONS] Get Validations Failure', props<{ error: string }>());

export const setPreviousMarginId = createAction('[VALIDATIONS] Set PreviousMarginId ', props<{ previousMarginId: number }>());
